import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Campaigns from './Campaigns';
import Foundations from './Foundations';

const Marketplace = () => {
  const [Page, setPage] = useState(2);
  const company = useParams();

  useEffect(() => {
    if (company.company === 'gt') {
      setPage(1);
    }
  }, [company]);

  useEffect(() => {
    const fetchValidatedCampaigns = async () => {};
    fetchValidatedCampaigns();
  }, []);
  return (
    <main id='page'>
      <div className='market-cards'>
        <div className='button-bar'>
          <button
            className={Page === 1 ? 'active' : ''}
            onClick={() => setPage(1)}>
            Fundaciones
          </button>
          <button
            className={Page === 2 ? 'active' : ''}
            onClick={() => setPage(2)}>
            Campañas
          </button>
        </div>
        {Page === 1 ? (
          <Foundations company={company} />
        ) : (
          <Campaigns company={company} />
        )}
      </div>
    </main>
  );
};

export default Marketplace;
